import { MAINNET_RELAY_API, setParams } from '@reservoir0x/relay-sdk';
import fetcher from '../fetcher.js';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
export const queryTokenPrice = function (baseApiUrl = MAINNET_RELAY_API, options) {
    const url = new URL(`${baseApiUrl}/currencies/token/price`);
    setParams(url, options ?? {});
    return fetcher(url.href);
};
export default function (baseApiUrl, options, queryOptions) {
    const response = useQuery({
        queryKey: ['useTokenPrice', options],
        queryFn: () => queryTokenPrice(baseApiUrl, options),
        retry: false,
        ...queryOptions
    });
    return useMemo(() => {
        return {
            ...response
        };
    }, [response.data, response.error, response.isLoading]);
}
//# sourceMappingURL=useTokenPrice.js.map